import script from "./ViewGeneratePVWithoutWarrantPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewGeneratePVWithoutWarrantPage.vue?vue&type=script&setup=true&lang=js"

import "./ViewGeneratePVWithoutWarrantPage.vue?vue&type=style&index=0&id=bdbb7308&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bdbb7308"]])

export default __exports__